import { observer } from 'mobx-react-lite';
import { useCallback, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

import { THEMES } from 'src/app/theme/consts';
import { useService } from 'src/packages/di';
import { Flicker } from 'src/pages/dashboard/features/anomaly-notifications-service/Flicker';

import styles from './ScreenFlickerOverlay.module.scss';

export const ScreenFlickerOverlay = observer(function ScreenFlickerOverlay() {
  const { flicker } = useService('anomalyNotificationsService');
  const theme = useService('theme');

  const overlayRef = useRef<HTMLDivElement>(null);

  const animateFlicker = useCallback(() => {
    const overlay = overlayRef.current;
    if (!overlay) {
      return;
    }

    const maxOpacity = theme.theme === THEMES.dark ? 0.3 : 0.35;

    overlay.getAnimations?.().forEach((animation) => animation.cancel());
    overlay.animate([{ opacity: 0 }, { opacity: maxOpacity, offset: 0.25 }, { opacity: 0 }], {
      duration: Flicker.INTERVAL_MS / 1.8,
      easing: 'ease-in-out',
    });
  }, [theme.theme]);

  useEffect(() => {
    const dispose = flicker.subscribe(animateFlicker);
    return () => {
      dispose();
    };
  }, [animateFlicker, flicker]);

  return createPortal(<div ref={overlayRef} className={styles.screenFlickerOverlay} />, document.body);
});
